import { render, staticRenderFns } from "./SessionClass.vue?vue&type=template&id=3619ea9c&scoped=true&"
import script from "./SessionClass.vue?vue&type=script&lang=js&"
export * from "./SessionClass.vue?vue&type=script&lang=js&"
import style0 from "./SessionClass.vue?vue&type=style&index=0&id=3619ea9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3619ea9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
